import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import { selectLogin, selectClient } from '../../../../store/login/loginSlice';
import { isMobile } from 'react-device-detect';
import {
  Stack,
  Typography,
  Card,
  Button,
  TextField,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Tab
  // Autocomplete
} from '@mui/material';
import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing
} from 'devextreme-react/data-grid';

import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import MoreMenu from '../../../components/multiplesComponents/MoreMenu';
import configAxios from '../../../../services/configAxios';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import LinkRegioes from './LinkRegioes';

const addEditProducts = (props) => {
  const navigation = useNavigate();
  const location = useLocation();
  const { state, pathname } = location;
  const pathNameSplice = pathname.split('/');
  const [infosProduct, setInfosProduct] = useState(state ? { ...state.infosEdit } : {});

  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });

  const [infosRegioes, setInfosRegioes] = useState([]);
  const [value, setValue] = useState('1');
  const [openModalRegioes, setOpenModalRegioes] = useState(false);
  const [infosTypesOfHiring, setInfosTypesOfHiring] = useState([]);

  const company = useSelector(selectClient);

  const allowedPageSizes = [5, 10, 20, 30];

  useEffect(() => {
    if (state === null && pathNameSplice[2] === 'editProducts') [navigation('/app/products')];
    if (infoState.controlaregiao === 'Sim') {
      getRegioesProducts();
    }
    getTypesOfHiring();
  }, []);

  function getRegioesProducts() {
    configAxios
      .get(`/products/getRegioesProducts/${infosProduct.codplano}`)
      .then((response) => {
        // console.log(response.data);
        setInfosRegioes(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades buscar as regiões no momento, por favor tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleInputChange(event, autocomplete) {
    if (autocomplete) {
      if (event) {
        setInfosProduct({
          ...infosProduct,
          labelregiao: event.label,
          id_regiao: event.idregiao
        });
        return;
      }
      return;
    }
    setInfosProduct({ ...infosProduct, [event.target.name]: event.target.value });
  }

  function HandleSubmit(event) {
    event.preventDefault();
    const router = infosProduct.id ? '/products/updateProduct' : '/products/addProduct';
    configAxios
      .post(router, infosProduct)
      .then((response) => {
        const message = infosProduct.id
          ? 'Produto atualizado com sucesso!'
          : 'Produto inserido com sucesso!';

        NotificationManager.success(message, 'Sucesso');

        setInfosProduct({
          ...infosProduct,
          id: response.data.id,
          codplano: response.data.codplano
        });

        const nav = infosProduct.id
          ? `/app/editProducts/${infosProduct.id}`
          : `/app/editProducts/${response.data.id}`;

        navigation(nav, {
          state: {
            infosEdit: {
              ...infosProduct,
              id: infosProduct.id ? infosProduct.id : response.data.id
            }
          }
        });
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function handleTabsChange(event, newValue) {
    setValue(newValue);
  }

  function LinktemsModalPlans() {
    setOpenModalRegioes(true);
  }

  function ActionsButtonsPlans(items) {
    const infos = [];
    infos.push(items.data.data);
    return infos.map((item) => (
      <MoreMenu
        key={item.id}
        infos={{
          id: item.id,
          deleteRouter: '/products/deleteProductsRegiao',
          deleteItem: 'a região do produto',
          functionGrid: getRegioesProducts,
          disabledEdit: true,
          otherInfos: item
        }}
      />
    ));
  }
  async function getTypesOfHiring() {
    configAxios
      .get(`/config/getTypesOfHiring`)
      .then((response) => {
        setInfosTypesOfHiring(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades buscar os tipos de contratação no momento, por favor tente novamente!',
          'Atenção'
        );
      });
  }
  return (
    <RenderPage title="Produtos" id="products">
      <>
        <LinkRegioes
          openModal={openModalRegioes}
          setOpenModal={setOpenModalRegioes}
          functionGrid={getRegioesProducts}
          otherInfos={infosRegioes}
          codplano={infosProduct.codplano}
        />
        <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
          <Grid container>
            <BreadcrumbsNav {...props} />
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Typography variant="h4" gutterBottom>
                Cadastro de produtos
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Utilize as opções abaixo para inserir e editar os produtos
              </Typography>
            </Grid>
          </Grid>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            {!isMobile && (
              <Button
                variant="outlined"
                color="error"
                component={RouterLink}
                to="/app/products"
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            )}
          </Stack>
        </Stack>
        <Card>
          <CustomGrid>
            <form onSubmit={HandleSubmit}>
              <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200', p: 2 }}>
                <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  {infosProduct.id && (
                    <Grid item xs={3} md={1}>
                      <TextField
                        name="idproduct"
                        fullWidth
                        label="ID"
                        variant="outlined"
                        size="small"
                        required
                        value={infosProduct.id || ''}
                        disabled
                      />
                    </Grid>
                  )}
                  {infosProduct.codplano && (
                    <Grid item xs={6} md={2}>
                      <TextField
                        name="codplano"
                        fullWidth
                        label="Código do produto/plano"
                        variant="outlined"
                        size="small"
                        required
                        value={infosProduct.codplano || ''}
                        disabled
                      />
                    </Grid>
                  )}
                </Grid>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={12} md={3}>
                    <TextField
                      name="descplano"
                      fullWidth
                      label="Descrição do plano"
                      variant="outlined"
                      size="small"
                      required
                      value={infosProduct.descplano || ''}
                      onChange={(event) => HandleInputChange(event)}
                      inputProps={{ maxLength: 200 }}
                    />
                  </Grid>
                  <Grid item xs={12} md={2.5}>
                    <InputLabel
                      id="label"
                      sx={isMobile ? { mt: 0 } : { fontSize: '13px', mt: -2.2 }}>
                      Tipo de contratação *
                    </InputLabel>
                    <Select
                      name="tpcontrat"
                      fullWidth
                      size="small"
                      required
                      value={infosProduct.tpcontrat || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {/* <MenuItem value={'1-INDIVIDUAL/FAMILIAR'}>1-INDIVIDUAL/FAMILIAR</MenuItem>
                      <MenuItem value={'2-COLETIVO EMPRESARIAL'}>2-COLETIVO EMPRESARIAL</MenuItem>
                      <MenuItem value={'3-COLETIVO POR ADESAO'}>3-COLETIVO POR ADESÃO</MenuItem> */}
                      {infosTypesOfHiring.map((item) => (
                        <MenuItem key={item.id} value={item.tpcontrat}>
                          {item.tpcontrat}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  {infoState.tipooperacao !== 'Cartão' && (
                    <Grid item xs={12} md={2}>
                      <TextField
                        name="regplano"
                        fullWidth
                        label="Registro ANS"
                        variant="outlined"
                        size="small"
                        required
                        value={infosProduct.regplano || ''}
                        onChange={(event) => HandleInputChange(event)}
                        inputProps={{ maxLength: 10 }}
                      />
                    </Grid>
                  )}
                  {infoState.modalidadecontrato === 'Contrato por plano' &&
                    infosProduct.tpcontrat !== '3-COLETIVO POR ADESAO' &&
                    infoState.tipo === 'Complexo' && (
                      <Grid item xs={12} md={2}>
                        <TextField
                          name="codcontrato"
                          fullWidth
                          label="Código do contrato"
                          variant="outlined"
                          size="small"
                          required
                          value={infosProduct.codcontrato || ''}
                          onChange={(event) => HandleInputChange(event)}
                          inputProps={{ maxLength: 10 }}
                        />
                      </Grid>
                    )}
                  {infoState.tipointegracao !== 'Não possui' && (
                    <Grid item xs={12} md={2}>
                      <TextField
                        name="codext"
                        fullWidth
                        label="Código externo"
                        variant="outlined"
                        size="small"
                        required
                        value={infosProduct.codext || ''}
                        onChange={(event) => HandleInputChange(event)}
                        inputProps={{ maxLength: 10 }}
                      />
                    </Grid>
                  )}
                  {infoState.tipointegracao !== 'Não possui' &&
                    infoState.integraterceiros === 'Sim' && (
                      <Grid item xs={12} md={2}>
                        <TextField
                          sx={
                            infosProduct.tpcontrat !== '3-COLETIVO POR ADESAO' &&
                            infoState.tipooperacao !== 'Cartão'
                              ? { mt: 2, fontSize: '13px' }
                              : { mt: 0, fontSize: '13px' }
                          }
                          name="codextterceiros"
                          fullWidth
                          label="Código externo terceiros"
                          variant="outlined"
                          size="small"
                          required
                          value={infosProduct.codextterceiros || ''}
                          onChange={(event) => HandleInputChange(event)}
                          inputProps={{ maxLength: 10 }}
                        />
                      </Grid>
                    )}
                  {infoState.tipointegracao !== 'Não possui' && infoState.tipo === 'Complexo' && (
                    <Grid item xs={12} md={1.5}>
                      <InputLabel
                        id="label"
                        sx={
                          infosProduct.tpcontrat !== '3-COLETIVO POR ADESAO' &&
                          infoState.tipooperacao !== 'Cartão'
                            ? { mt: 0, fontSize: '13px' }
                            : { mt: -1, fontSize: '13px' }
                        }>
                        Status *
                      </InputLabel>
                      <Select
                        name="status"
                        fullWidth
                        size="small"
                        required
                        value={infosProduct.status || ''}
                        onChange={(event) => HandleInputChange(event)}>
                        <MenuItem value={'ATIVO'}>Ativo</MenuItem>
                        <MenuItem value={'INATIVO'}>Inativo</MenuItem>
                      </Select>
                    </Grid>
                  )}
                  {(infoState.tipointegracao === 'Não possui' || infoState.tipo !== 'Complexo') && (
                    <Grid item xs={12} md={2}>
                      <InputLabel
                        id="label"
                        sx={
                          isMobile
                            ? { mt: 0 }
                            : {
                                fontSize: '13px',
                                mt: infoState.integraterceiros === 'Sim' ? 0.5 : -2.2,
                                ml: infoState.integraterceiros === 'Sim' ? 1.5 : 0
                              }
                        }>
                        Status *
                      </InputLabel>
                      <Select
                        name="status"
                        fullWidth
                        size="small"
                        required
                        value={infosProduct.status || ''}
                        onChange={(event) => HandleInputChange(event)}>
                        <MenuItem value={'ATIVO'}>Ativo</MenuItem>
                        <MenuItem value={'INATIVO'}>Inativo</MenuItem>
                      </Select>
                    </Grid>
                  )}
                  {infoState.tipo === 'Simples c/odonto' && (
                    <Grid item xs={12} md={2}>
                      <InputLabel
                        id="label"
                        sx={
                          isMobile
                            ? { mt: 0 }
                            : {
                                fontSize: '13px',
                                mt: infoState.integraterceiros === 'Sim' ? 0.5 : 0.5
                              }
                        }>
                        Produto odontológico? *
                      </InputLabel>
                      <Select
                        name="odontologico"
                        fullWidth
                        size="small"
                        required
                        value={infosProduct.odontologico || ''}
                        onChange={(event) => HandleInputChange(event)}>
                        <MenuItem value={'Sim'}>Sim</MenuItem>
                        <MenuItem value={'Não'}>Não</MenuItem>
                      </Select>
                    </Grid>
                  )}
                </Grid>
                <Grid container spacing={2} sx={{ mt: 0.5 }}>
                  {company === 'higiasaude' && (
                    <Grid item xs={12} md={3}>
                      <TextField
                        name="qtdevidassimulations"
                        fullWidth
                        label="Quantidade de vidas para simulação"
                        variant="outlined"
                        size="small"
                        type="number"
                        value={infosProduct.qtdevidassimulations || ''}
                        onChange={(event) => HandleInputChange(event)}
                        inputProps={{ maxLength: 10 }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
              {infosProduct.id && infoState.controlaregiao === 'Sim' && (
                <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200' }}>
                  <TabContext value={value} variant="scrollable" scrollButtons="auto">
                    <Box sx={{ mt: 3, p: 1 }}>
                      <TabList onChange={handleTabsChange} aria-label="RegioesTabs">
                        <Tab label="Regiões" value="1" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <Stack direction="row" alignItems="center" justifyContent="end">
                        {!isMobile && (
                          <Grid container>
                            <Grid item>
                              <CustomInfosForm>Vincular regiões aos produtos</CustomInfosForm>
                            </Grid>
                          </Grid>
                        )}
                        {!isMobile && (
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ mb: 1 }}>
                            <Button
                              variant="contained"
                              onClick={LinktemsModalPlans}
                              startIcon={<Iconify icon="eva:plus-fill" />}>
                              Novo
                            </Button>
                            <Button
                              variant="outlined"
                              onClick={getRegioesProducts}
                              sx={{ ml: 1 }}
                              startIcon={<Iconify icon="eva:refresh-outline" />}>
                              Atualizar
                            </Button>
                          </Stack>
                        )}
                        {isMobile && (
                          <Grid item xs={12} sx={{ mb: 3 }}>
                            <Stack direction="row" alignItems="center" justifyContent="end">
                              <Button
                                variant="contained"
                                onClick={LinktemsModalPlans}
                                startIcon={<Iconify icon="eva:plus-fill" />}>
                                Novo
                              </Button>
                            </Stack>
                          </Grid>
                        )}
                      </Stack>
                      <DataGrid
                        dataSource={infosRegioes}
                        showBorders={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnAutoWidth={true}
                        noDataText={'Não há regiões vinculadas'}>
                        <Column dataField="descregiao" caption="Descrição da região" />
                        <Column
                          dataField="Ações"
                          width={200}
                          allowSorting={false}
                          cellRender={(data) => <ActionsButtonsPlans data={data} />}
                        />
                        <SearchPanel visible={true} width={253} placeholder="Procurar..." />
                        {!isMobile && (
                          <GroupPanel
                            visible={true}
                            emptyPanelText="Arraste as colunas aqui para agrupar"
                          />
                        )}
                        <Scrolling rowRenderingMode="virtual"></Scrolling>
                        <Paging defaultPageSize={10} />
                        <Pager
                          visible={true}
                          allowedPageSizes={allowedPageSizes}
                          showPageSizeSelector={true}
                          showInfo={true}
                          showNavigationButtons={true}
                        />
                        <ColumnChooser
                          enabled={true}
                          title={'Escolher uma coluna'}
                          emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                        />
                        <ColumnFixing enabled={true} />
                        <HeaderFilter visible={true} allowSearch={true} />
                      </DataGrid>
                    </TabPanel>
                  </TabContext>
                </Box>
              )}
              <Stack direction="row" justifyContent="end" sx={{ mt: 5 }}>
                <Button
                  type="submit"
                  variant="contained"
                  size="medium"
                  color="success"
                  sx={{ mr: 2 }}
                  startIcon={<Iconify icon="eva:save-fill" />}>
                  {infosProduct.id ? 'Atualizar' : 'Salvar'}
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  component={RouterLink}
                  to="/app/products"
                  startIcon={<Iconify icon="eva:close-circle-fill" />}>
                  Cancelar
                </Button>
              </Stack>
            </form>
          </CustomGrid>
        </Card>
      </>
    </RenderPage>
  );
};

export default addEditProducts;
